// COLORS
export var BLACK = '#000';
export var WHITE = '#FFF';
// grey scale
export var GREY = '#2E3141';
export var GREY_700 = '#37415';
export var GREY_500 = '#F9FAFB';
export var GREY_400 = '#9FA4AF';
export var GREY_300 = '#E5E7EB';
export var GREY_100 = '#BAB8CB';
export var GREY_SECONDARY = '#706E83';
export var GREY_LIGHT = '#E7E7E7';
export var GREY_LIGHTER = '#ECECEC';
export var GREY_MID = '#6B7280';
export var GREY_ICON = '#C4C5C9';
export var GREY_666 = '#666';
export var GREY_SWEET = '#F0F0F0';
export var GREY_SOFT = '#6B6A69';
export var WHITE_SMOKE_GREY = '#F7F7F7';
export var LIGHT_GREY = '#D3D3D3';
export var GREY_COLOR = '#bababa';
export var GREY_WHITE = '#F3F4F6';
export var GREY_DARK = '#364153';
export var GREY_BORDER = '#EBE6E7';
export var GREY_BORDER_MID = '#D9D9D9';
export var GREY_HOVER = '#F5F5F5';
export var GREY_NAV_HOVER = '#F3F4F7';
export var GREY_MUTED = '#8C8C8C';
export var GREY_LABEL = '#747474';
export var GREY_BACKGROUND = '#FAFAFA';
export var GREY_WARM = '#ECEDE5';
export var BLUE = '#2064D2';
export var BLUE_LIGHT = '#E2EEFF';
export var BLUE_LIGHTER = '#EFF6FF';
export var BLUE_500 = '#91D5FF';
export var BLUE_700 = '#1E90FF';
export var BLUE_MID = '#4085F1';
export var BLUE_DARK = '#111827';
export var LINK = '#1677ff';
export var BLUE_SECONDARY = '#183C84';
export var NAVY = '#12275E';
export var ORANGE = '#D97706';
export var ORANGE_LIGHT = '#FFF0D9';
export var ORANGE_MID = '#F2B649';
export var RED = '#E22020';
export var RED_LIGHT = '#FFCCC7';
export var RED_LIGHTER = '#FFF1F0';
export var RED_LIGHTEST = '#F8EAE5';
export var RED_500 = '#EF4444';
export var RED_400 = '#FF4D4F';
export var RED_DARK = '#CF1322';
export var RED_BADGE = '#B40707';
export var YELLOW = '#FFE58F';
export var YELLOW_LIGHT = '#FFFBE6';
export var YELLOW_DARK = '#FAAD14';
export var GREEN = '#B7EB8F';
export var GREEN_LIGHT = '#F6FFED';
export var GREEN_MID = '#52C41A';
export var GREEN_DARK = '#266B49';
export var GREEN_SOFT = '#E1F1E9';
export var GREEN_500 = '#00A63D';
export var PURPLE = '#722ED1';
export var PURPLE_LIGHT = '#F8F0FF';
export var PURPLE_AVATAR = '#D4B5D759';
export var GOLD = '#FFF1B8';
export var GOLD_DARK = '#D58805';
export var CYAN = '#E6FFFB';
export var CYAN_DARK = '#13C2C2';
export var AQUA_LIGHT = '#faebd7';
export var SILVER = '#c0c0c0';
export var ANTIQUE_WHITE = '#faebd7';
export var CHINESE_SILVER = '#ccc';
export var WII = '#999';
export var CAPAROL = '#e8e8e8';
export var BROWN = '#9C5400';
export var TRANSPARENT = 'transparent';
// FONTS
export var INTER = 'Inter';
